import React, { useEffect, useState } from "react";
import { Button, Card, Row, Select } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";
import { setUserSite, userSignOut } from "../appRedux/actions";
import { ReactComponent as LogoutIcon } from "../assets/images/logout.svg";

const Option = Select.Option;

const UserSiteSelection = ({ authUser, updateUserSite, userSignOut }) => {
  const [selectedSite, setSelectedSite] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (authUser?.site) {
        setSelectedSite(authUser.site);
    }
    if (!authUser) {
      navigate("/signin");
    }
  }, [authUser]);

  const handleContinue = () => {
    if (!selectedSite) return;
    updateUserSite(selectedSite);
    navigate("/user-role-selection"); // after site, go to role selection
  };

  return (
    <section className="auth-layout-container">
      <div className="gx-app-login-wrap">
        <div className="verify-container">
          <div>
            <h1 className="authenticator-heading">
              {`Hi, ${authUser?.firstName} ${authUser?.lastName}. Please select a site`}
            </h1>
          </div>
          <div className="verify-container-block" style={{ minHeight: "150px" }}>
              <Select
                placeholder="Select Site"
                style={{ width: 350 }}
                value={selectedSite ? selectedSite.mipId : undefined}
                onChange={(value) => {
                  const site = authUser?.mips?.find((s) => s.mipId === value);
                  setSelectedSite(site);
                }}
              >
                {authUser?.mips?.map((site) => (
                  <Option key={site.mipId} value={site.mipId}>
                    {site.name}
                  </Option>
                ))}
              </Select>
          </div>
          <div style={{     width: '440px', textAlign: 'center' }}>
              <Button
                  block
                  type="primary"
                  disabled={!selectedSite}
                  onClick={handleContinue}
                >
                Continue
              </Button>
              <Button
                style={{ background: "transparent", border: "none", marginTop: "20px" }}
                className={"clarity-submit-button"}
                onClick={userSignOut}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <LogoutIcon />
                  <span>{"Log out"}</span>
                </span>
              </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export const mapDispatchToProps = (dispatch) => ({
  userSignOut: bindActionCreators(userSignOut, dispatch),
  updateUserSite: bindActionCreators(setUserSite, dispatch),
});

const mapStateToProps = ({ auth }) => ({
  authUser: auth ? auth.authUser : null,
});

export default connect(mapStateToProps, mapDispatchToProps)(UserSiteSelection);
